<template>
  <div>
    <div v-if="title">
      <h3>{{ title }}</h3>
    </div>
    <div
      class="row justify-content-center pb-2 pb-xl-1"
      v-if="sortedCalendar && sortedCalendar.length > 0"
    >
      <CalendarItem
        v-for="item in sortedCalendar"
        v-bind:key="item.id"
        v-bind:item="item"
        v-bind:variant="variant"
      />
    </div>
    <div class="pb-2 pb-xl-1" v-if="sortedCalendar === null">
      <span class="text-muted">Loading ...</span>
    </div>
    <div
      class="pb-2 pb-xl-1"
      v-if="sortedCalendar !== null && sortedCalendar.length == 0"
    >
      <span class="text-muted">No upcoming quizzes.</span>
    </div>
  </div>
</template>

<script>
import CalendarItem from "@/components/CalendarItem";
import { mapGetters } from "vuex";

export default {
  name: "Calendar",
  props: {
    variant: {
      default: "left"
    },
    title: {
      default: ""
    }
  },
  components: {
    CalendarItem
  },
  computed: {
    ...mapGetters({ sortedCalendar: "quizStore/sortedCalendar" })
  },
  created() {
    this.$store.dispatch("quizStore/loadCalendar", this);
  }
};
</script>
